import React from 'react'
import { AchievementInfoCon, ActionsCon } from './styles'
import { RightArrow } from '../Icons'
import { colors } from '../consts'
import { addCommas } from '../../Utils'
import { CopyIcon } from '../Buttons/CopyIcon'
import { LinkBtn } from '../Buttons/LinkBtn'

type AchievementInfoProps = {
  progressTitle: string
  progress: number
  showActionBtn: boolean
  link?: string
  btnText?: string
}

export const AchievementInfo: React.FC<AchievementInfoProps> = ({
  progressTitle,
  progress,
  showActionBtn,
  link,
  btnText,
}) => {


  return (
    <AchievementInfoCon>
      <div className="progressCon">
        <h3 className="progressTitle">{progressTitle}</h3>
        <h3 className="progress">{progress > 0 ? addCommas(progress) : `Starts 7/2`}</h3>
      </div>
      <div className="achRight">
        {link && (
          <ActionsCon>
            <CopyIcon link={link} size={'lg'} border={false} theme="dark" />
            {showActionBtn && !btnText && <RightArrow fill={colors.yellow} />}
            {showActionBtn && btnText && (
              <LinkBtn href={link} btnStyle="primary" aria-label={btnText}>
                {btnText}
              </LinkBtn>
            )}
          </ActionsCon>
        )}
      </div>
    </AchievementInfoCon>
  )
}
